<template>
  <div class="row m-0 p-0">
    <div class="col-lg-6 ml-0 pl-0">
      <b-table :fields="finalGradeFinalGradesModalFields"
               :items="[{...proposal, _showDetails: true}]"
               class="table-responsive"
               head-variant="light"
               responsive
               striped>
        <template v-slot:cell(created_at)="row">
          {{ row.item.states.date | moment('DD-MM-YYYY HH:mm') }}
        </template>
        <template v-slot:cell(actions)="row">
          <action-download-pdf :proposal="row.item"/>
        </template>
        <template v-slot:row-details>
          <b-table :fields="finalGradeFinalGradesModalDetailsFields"
                   :items="[proposal]"
                   bordered
                   class="table-responsive"
                   hover
                   responsive
                   small
                   stacked>
          </b-table>
        </template>
      </b-table>
      <final-grade-form v-model="proposal"
                        :is-editable="isManagementEvaluation ? false : isFinalGradeEditable"
                        :shiftsCounterData="isManagementEvaluation ? {} : shiftsCounterData"
                        @close-modal="closeModalEmit"/>
    </div>

    <div class="col-lg-6 mr-0 pr-0">
      <evaluations-summary-table :value="proposal"/>
      <div v-if="isManagementEvaluation">
        <management-evaluation-form v-model="proposal"
                                    :isUserEditor="isUserEditor"
                                    :shiftsCounterData="shiftsCounterData"
                                    @close-modal="closeModalEmit"/>
      </div>
    </div>
  </div>
</template>

<script>
  import ActionDownloadPdf from '@/components/actions/ActionDownloadPdf';
  import { infrastructureMixin } from '@/mixins/infrastructure';
  import FinalGradeForm from '@/components/evaluation/final-grade/FinalGradeForm';
  import EvaluationsSummaryTable from '@/components/evaluation/EvaluationsSummaryTable';
  import ManagementEvaluationForm from '@/components/evaluation/management/ManagementEvaluationForm';
  import options from '@/json/feasibility';

  export default {
    name: 'GradeModal',
    components: {
      ActionDownloadPdf,
      FinalGradeForm,
      EvaluationsSummaryTable,
      ManagementEvaluationForm,
    },
    mixins: [infrastructureMixin],
    props: {
      value: {
        type: Object,
        default: () => {
        },
      },
      isUserEditor: {
        type: Boolean,
        required: true,
      },
      isManagementEvaluation: {
        type: Boolean,
        required: true,
      },
      shiftsCounterData: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        proposal: this.value,
        options: options.options,
        finalGradeFinalGradesModalFields: [],
        finalGradeFinalGradesModalDetailsFields: [],
      };
    },
    computed: {
      isFinalGradeEditable() {
        const isFinalGradeStateEditable = this.proposal.final_grade?.states?.name !== 'submitted';
        return this.isUserEditor && isFinalGradeStateEditable;
      },
    },
    watch: {
      value() {
        this.proposal = this.value;
      },
      proposal: {
        handler() {
          this.$emit('input', this.proposal);
        },
        deep: true,
      },
    },
    async created() {
      const helpers = await this.getEvaluationDashboardProperties(
        this.infrastructure,
        'FinalGrade',
      );
      this.finalGradeFinalGradesModalFields = helpers.getSingleField('finalGradeFinalGradesModalFields');
      this.finalGradeFinalGradesModalDetailsFields = helpers.getSingleField('finalGradeFinalGradesModalDetailsFields');
    },
  };
</script>

<style lang="scss" scoped>
  .table-responsive {
    margin-bottom: 0;
  }

  .header {
    color: #495057;
  }
</style>
